import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import { CachedDataService } from '@services/data/cached-data.service';
import { SignInRequest } from '@models/requests/sign-in-request';
import { SignInResponse } from '@models/responses/sign-in-response';
import { SignUpRequest } from '@models/requests/sign-up-request';
import { SignUpResponse } from '@models/responses/sign-up-response';
import { SendCodeRequest } from '@models/requests/send-code-request';
import { PasswordRecoveryRequest } from '@models/requests/password-recovery-request';
import { PasswordConfirnRequest } from '@models/requests/password-confirm-request';


import { Observable } from 'rxjs/Observable';
import { environment } from '@environments';
import { ScreenService } from '@services/screen.service';
import { Router } from '@angular/router';


@Injectable()
export class AuthService {

  constructor(
    private httpClient: HttpClient,
    private screenService: ScreenService,
    private cachedDataService: CachedDataService,
    private router: Router) { }

  needUpdatePasswordSubject: Subject<boolean> = new Subject<boolean>();
  needUpdatePasswordObservable = this.needUpdatePasswordSubject.asObservable();

  userUpdatePasswordSubject: Subject<boolean> = new Subject<boolean>();
  userUpdatePasswordObservable = this.userUpdatePasswordSubject.asObservable();

  signIn(login: string, password: string) {
    const request = new SignInRequest(login, password);
    const uri = environment.apiUri + 'user/signin';

    return this.httpClient.post<SignInResponse>(uri, request)
      .toPromise()
      .then(loginResponse => loginResponse);
    // .catch(this.utils.handleError)

  }
  signUp(username: string, password: string, fullname: string, phoneNumber: string, email: string, dateTimeOffset: number) {
    const request = new SignUpRequest(username, password, fullname, phoneNumber, email, dateTimeOffset);
    const uri = environment.apiUri + 'user/signup';
    return this.httpClient.post<SignUpResponse>(uri, request)
      .toPromise()
      .then(response => response);
    // .catch(this.utils.handleError)
  }
  signOut() {
    this.cachedDataService.clearCache();
    this.router.navigate(['/']);
  }
  passwordRecovery(login: string, NewPassword: string, Channel: string) {
    const request = new PasswordRecoveryRequest(login, NewPassword, Channel);
    const uri = environment.apiUri + 'user/passwordRecovery';

    return this.httpClient.post(uri, request)
      .toPromise()
      .then(response => response);
    // .catch(this.utils.handleError)

  }
  passwordConfirm(login: string, code: string) {
    const request = new PasswordConfirnRequest(login, code);
    const uri = environment.apiUri + 'user/passwordConfirm';

    return this.httpClient.put(uri, request)
      .toPromise()
      .then(response => response);
    // .catch(this.utils.handleError)
  }

  helpRequest(body) {


    const uri = environment.apiUri + 'user/helpRequest';

    return this.httpClient.post(uri, body)
      .toPromise()
      .then(response => response);
    // .catch(this.utils.handleError)

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/http/auth.service.ts